// removed by extract-text-webpack-plugin
module.exports = {"drillViewContainer":"xA5gObRxCvTcOex4l8Yg9","drillViewPanel":"_14I_gtPNLuskG5B50rfsp4","subMenu":"_3YHy_YpkVLb4EzTUvjGiit","openSubMenu":"_39UbVxJ9kX16LZXAwWkyS5"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideMenu/DrillView/DrillView.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideMenu/DrillView/DrillView.scss
// module chunks = 0